import { AUTH_SERVICE } from "@/datas/authservice";

export default Object.freeze({
  display: (value) => {
    return value === "T" ? "진열" : "진열안함";
  },
  selling: (value) => {
    return value === "T" ? "판매중" : "판매안함";
  },
  paymentTypeText: (value) => {
    switch (value) {
      case "card":
        return "카드";
      case "bank":
        return "무통장";
      case "phone":
        return "휴대폰";
      case "virtual":
        return "가상계좌";
      case "point":
        return "포인트";
      case "kakao":
        return "카카오페이";
      case "naver":
        return "네이버페이";
      case "toss":
        return "토스";
      case "payco":
        return "페이코";
      case "samsung":
        return "삼성페이";
      case "kpay":
        return "KPAY";
      case "lpay":
        return "LPAY";
      case "culture":
        return "문화상품권";
      case "happymoney":
        return "해피머니";
      case "booknlife":
        return "도서문화상품권";
      case "cashbee":
        return "캐시비";
      case "okcashbag":
        return "OK캐시백";
      case "kakaopay":
        return "카카오페이";
    }
  },
  msgTypeText: (value) => {
    switch (value) {
      case "payment_end":
        return "결제완료 상태가 되면 발송";
      case "shipping_start":
        return "배송중 상태가 되면 발송";
      case "shipping_end":
        return "배송완료 상태가 되면 발송";
      case "buyed_confirm":
        return "구매확정 상태가 되면 발송";
      case "cancel_start":
        return "취소접수 상태가 되면 발송";
      case "cancel_end":
        return "취소완료 상태가 되면 발송";
      case "exchange_start":
        return "교환접수 상태가 되면 발송";
      case "exchange_end":
        return "교환완료 상태가 되면 발송";
      case "refund_start":
        return "반품접수 상태가 되면 발송";
      case "refund_end":
        return "반품완료 상태가 되면 발송";
      case "member_cert_end":
        return "쇼핑몰에서 고객이<br/>인증 완료하면 발송";
      case "admin_cert_end":
        return "앱에서 관리자가 <br/>인증 완료하면 발송";
      case "admin_approval_end":
        return "앱에서 관리자가 <br/>승인 완료하면 발송";
      case "expired_before":
        return "정품 보증 기간<br/>만료 전 발송";
      case "expired_after":
        return "정품 보증 기간<br/>만료 후 발송";
      case "member_cert_cancel":
        return "쇼핑몰에서 고객이<br/>인증 취소하면 발송";
      case "admin_cert_cancel":
        return "앱에서 관리자가 <br/>인증 취소하면 발송";
      case "member_lost_regist":
        return "쇼핑몰에서 고객이<br/>분실 변경하면 발송";
      case "admin_lost_regist":
        return "앱에서 관리자가 <br/>분실 변경하면 발송";
      case "member_lost_cancel":
        return "쇼핑몰에서 고객이<br/>분실 취소하면 발송";
      case "lost_3rd_verify_member":
        return "분실 상품을 제3자가 인증 시도시<br/>분실 신청한 고객에게 발송";
      case "lost_3rd_verify_admin":
        return "분실 상품을 제3자가 인증 시도시<br/>관리자에게 발송";
      case "receipt_waiting":
        return "A/S 접수대기";
      case "receipt_done":
        return "A/S 접수완료";
      case "center_in":
        return "A/S 센터입고";
      case "payment_waiting":
        return "A/S 결제대기";
      case "payment_done":
        return "A/S 결제완료";
      case "as_done":
        return "A/S 수리완료";
      case "shipping_done":
        return "A/S 발송완료";
      case "done":
        return "A/S 완료";
      default:
        return "미발송";
    }
  },
  sendTypeText: (value) => {
    switch (value) {
      case "kakao_sms_email":
        return "카카오톡 + SMS + 메일 발송";
      case "kakao_email":
        return "카카오톡 + 메일 발송 (카카오톡 발송 실패시 SMS 발송 처리)";
      case "kakao":
        return "카카오톡 발송 (카카오톡 발송 실패시 SMS 발송 처리)";
      case "sms_email":
        return "SMS + 메일 발송";
      case "sms":
        return "SMS 발송";
      case "email":
        return "메일 발송";
      default:
        return "미설정";
    }
  },
  certStatus: (value) => {
    if (value === "inactivated") {
      return "미인증";
    } else if (value === "activated") {
      return "인증완료";
    } else if (value === "lost") {
      return "분실";
    } else if (value === "approved") {
      return "승인완료";
    } else {
      return "-";
    }
  },
  defaultString: (value) => {
    return !value ? "-" : value;
  },
  defaultDate: (value) => {
    if (!value) {
      return "-";
    } else {
      let date = value.split(" ");
      return `${date[0]}</br>${date[1]}`;
    }
  },
  numberFormat: (value) => {
    if (!value) {
      return value;
    } else {
      value += "";
      var whole, fraction;
      let decIndex = value.lastIndexOf(".");
      if (decIndex > 0) {
        whole = value.substr(0, decIndex);
        fraction = value.substr(decIndex);
      } else {
        whole = value;
      }
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(whole)) {
        whole = whole.replace(rgx, "$1" + "," + "$2");
      }
      return fraction ? whole + fraction : whole;
    }
  },
  excelErrorMessages: (data) => {
    return data.toString().replace(",", "</br>");
  },
  validatedAndExpiredAt: (data) => {
    if (data.cert_validated_at && data.cert_expired_at) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      return "-";
    }
  },
  warrantyPeriod: (data) => {
    let items = {
      d: "일",
      m: "개월",
      y: "년",
    };
    if (data.cert_validated_at !== null && data.cert_validated_at !== undefined && data.cert_duration_type !== AUTH_SERVICE.BOUGHT) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      let count = data.cert_duration.replace(/[a-z]/gi, "");
      let type = data.cert_duration.replace(/[0-9]/g, "").toLowerCase();
      let text = "";

      // 구매일 기준
      if (data.cert_duration_type == AUTH_SERVICE.BOUGHT && data.bought_at && data.cert_duration) {
        let validatedAt = data.bought_at.substr(0, 10);
        let date = new Date(validatedAt);
        let y = 0;
        let m = 0;
        let d = 0;
        if (type == "y") {
          y += Number(count);
          date.setFullYear(date.getFullYear() + y);
        }
        if (type == "m") {
          m += Number(count);
          date.setMonth(date.getMonth() + m);
        }
        if (type == "d") {
          d += Number(count);
          date.setDate(date.getDate() + d);
        }
        let yyyy = date.getFullYear().toString();
        let mm = (date.getMonth() + 1).toString();
        let dd = date.getDate().toString();
        let expiredAt = yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]);
        return `${validatedAt}</br>~${expiredAt}`;
      }

      if (data.cert_duration_type == AUTH_SERVICE.ACTIVATED) {
        text = "인증일로부터";
      } else if (data.cert_duration_type == AUTH_SERVICE.CREATED) {
        text = "생성일로부터";
      } else {
        text = "구매일로부터";
      }
      return `${text}</br>${count}${items[type]}`;
    }
  },
});
